import { round } from 'lodash';

export const ttc2ht = ({ ttc, tva }) => parseFloat(ttc) / (1 + parseFloat(tva) / 100);
export const ht2ttc = ({ ht, tva }) => parseFloat(ht) * (1 + parseFloat(tva) / 100);

const computeParams = ({ associations, query, pagination }) => {
  let params = [];

  if (pagination?.limit && pagination?.page) {
    params = [`_limit=${pagination.limit}`, `_page=${pagination.page}`];
  }

  if (pagination?.sort) {
    params.push(`_sort=${pagination.sort}`);
  }

  if (associations && associations.length > 0) {
    params.push(`_associations=${associations.join(',')}`);
  }

  if (query) {
    params = [...params, ...Object.keys(query).map(key => `${key}=${query[key]}`)];
  }

  return params;
};

const calculPrixLot = (pxTTC, tva, txCommissionTTC, tvaTauxCom) => {
  const prixTTC = parseFloat(pxTTC);
  const prixHT = round(ttc2ht({ ttc: prixTTC, tva }), 2);
  const txCommissionHT = round(ttc2ht({ ttc: txCommissionTTC, tva: tvaTauxCom }), 2);
  const commissionTTC = round(prixTTC * (txCommissionTTC / 100), 2);

  return {
    prixTTC,
    prixHT,
    txCommissionHT,
    commissionTTC,
    commissionHT: round(commissionTTC / 1.2, 2),
    prixPromoteur: prixTTC - commissionTTC,
  };
};

export { computeParams, calculPrixLot };
